import type { SVGProps } from 'react';
const SvgIconArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8.97 3.58a.75.75 0 0 1 1.06-1.06l4.597 4.596a1.25 1.25 0 0 1 0 1.768L10.03 13.48a.75.75 0 1 1-1.06-1.06l3.255-3.67H1.75a.75.75 0 0 1 0-1.5h10.475z"
    />
  </svg>
);
export default SvgIconArrowRight;
